import React from "react";
import { Tab, Tabs, type TabProps, type TabsProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const RpSwitchTabs = styled(Tabs)(() => ({
  minWidth: "auto",
  minHeight: "auto",
  width: "auto",
  background: "var(--neutral-white)",
  borderRadius: "var(--radius-round)",
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const RpSwitchTab = styled(Tab)(({ theme }) => ({
  borderRadius: "var(--radius-round)",
  minWidth: "auto",
  minHeight: "auto",
  background: (theme.vars || theme)?.palette?.primary?.contrastText,
  color: (theme.vars || theme)?.palette?.primary?.main,
  // border: `1px solid ${theme.palette.primary.main}`,
  margin: "0",
  padding: "2px 16px",
  fontSize: 14,
  fontWeight: 600,
  textTransform: "none",
  opacity: 1,
  "&.Mui-selected": {
    background: (theme.vars || theme)?.palette?.primary?.main,
    color: (theme.vars || theme)?.palette?.primary?.contrastText,
  },
}));

const RpSwitchTabs1 = styled(Tabs)(() => ({
  minWidth: "auto",
  minHeight: "auto",
  width: "auto",
  background: "var(--neutral-white)",
  borderRadius: "var(--radius-container)",
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const RpSwitchTab1 = styled(Tab)(({ theme }) => ({
  borderRadius: "var(--radius-control)",
  minWidth: "auto",
  minHeight: "auto",
  background: "var(--neutral-200)",
  color: (theme.vars || theme)?.palette?.primary?.dark,
  // border: `1px solid ${theme.palette.primary.main}`,
  margin: -1,
  padding: "10px 1.4rem",
  fontSize: 12,
  fontWeight: 600,
  textTransform: "none",
  opacity: 1,
  "&.Mui-selected": {
    border: "1px solid var(--neutral-200)",
    background: (theme.vars || theme)?.palette?.primary?.main,
    color: (theme.vars || theme)?.palette?.primary?.contrastText,
    zIndex: 1,
    boxShadow: "none",
  },
}));

const scrollButtonsOff = "off" as unknown as TabsProps["scrollButtons"];

function SwitchTabs({
  tabs = [],
  selectedTab,
  onChange,
  tabProps = {},
  styleType = 1,
  ...rest
}: Omit<TabsProps, "onChange" | "value"> & {
  tabs?: React.ReactNode[];
  selectedTab?: TabsProps["value"];
  onChange?: (_newValue: unknown) => void;
  tabProps?: TabProps;
  styleType?: 1 | 2;
}) {
  const handleTabChange = (_event: React.SyntheticEvent, newValue: unknown) => {
    if (onChange) {
      onChange(newValue);
    }
  };
  if (styleType === 1) {
    return (
      <RpSwitchTabs1
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons={scrollButtonsOff}
        {...rest}
      >
        {tabs.map((tab) => {
          // eslint-disable-next-line react/jsx-key
          return <RpSwitchTab1 label={tab} {...tabProps} />;
        })}
      </RpSwitchTabs1>
    );
  }
  return (
    <RpSwitchTabs
      value={selectedTab}
      onChange={handleTabChange}
      variant="scrollable"
      scrollButtons={scrollButtonsOff}
      {...rest}
    >
      {tabs.map((tab) => {
        // eslint-disable-next-line react/jsx-key
        return <RpSwitchTab label={tab} {...tabProps} />;
      })}
    </RpSwitchTabs>
  );
}

export default SwitchTabs;
